import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import LockTwoToneIcon from "@mui/icons-material/LockTwoTone";
import { Tooltip } from "@mui/material";
import { ArrowDownwardRounded, ArrowForwardRounded, ArrowUpwardRounded } from "@mui/icons-material";
import './EWS.css'

const EWS = () => {
  const location = useLocation();
  const { cin } = location.state;
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const visibleIndex = "0-0";

  const handlePricing = () => {
    navigate(`/pricing`);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://nexensus.club/webapp/checker/alertByCin?cin=${cin}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [cin]);

  const renderArrowIcon = (weight) => {
    if (weight === -1) {
      return <ArrowDownwardRounded sx={{ color: "red" }} />;
    } else if (weight === 1) {
      return <ArrowUpwardRounded sx={{ color: "green" }} />;
    } else {
      return <ArrowForwardRounded sx={{ color: "yellow" }} />;
    }
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        <TableContainer component={Paper} sx={{ position: "relative" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>PAN</TableCell>
                <TableCell>CIN</TableCell>
                <TableCell>Trigger ID</TableCell>
                <TableCell>Trigger Detail</TableCell>
                <TableCell>Trigger Name</TableCell>
                <TableCell>Trigger Date</TableCell>
                <TableCell>Weight</TableCell>
                <TableCell>Source Link</TableCell>
                <TableCell>Reference</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
  {data.map((item, index) => (
    <TableRow
      key={index}
      sx={{
        filter: index >= 2 ? "blur(4px)" : "none",
        userSelect: index >= 2 ? "none" : "auto",
        pointerEvents: index >= 2 ? "none" : "auto", // Disable interaction for blurred rows
      }}
    >
      <TableCell>{item.name}</TableCell>
      <TableCell>{item.pan}</TableCell>
      <TableCell>{item.cin}</TableCell>
      <TableCell>{item.triggerId}</TableCell>
      <TableCell>
        <Tooltip title={item.triggerDetail}>
          <span>{item.triggerDetail}</span>
        </Tooltip>
      </TableCell>
      <TableCell>{item.triggerName}</TableCell>
      <TableCell>{item.triggerDate}</TableCell>
      <TableCell>
        {renderArrowIcon(item.weight)}
      </TableCell>
      <TableCell>
        <a href={item.sourceLink}>
          {item.sourceLink &&
            item.sourceLink.match(
              /(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+)\./
            )[1]}
        </a>
      </TableCell>
      <TableCell>{item.reference}</TableCell>
    </TableRow>
  ))}
</TableBody>
          </Table>
          <button
            onClick={handlePricing}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
            }}
          >
            <LockTwoToneIcon sx={{ color: "red", fontSize: "3rem" }} />
          </button>
        </TableContainer>
      )}
    </Container>
  );
};

export default EWS;
